import React from 'react';
import {
  DxContainer,
  DxGrid,
  DxProcessHeader,
  DxSpacer,
} from '@dvag/design-system-react';
import i18next from 'i18next';

import { TopCard } from 'component/TopCard/TopCard';
import { useScreenData } from './utils/useScreenData';

import { LeftCard } from 'component/BottomCards/leftCard/LeftCard';
import { RightCard } from 'component/BottomCards/rightCard/RightCard';

import './style.css';
import { BottomButtons } from '../../component/BottomButtons/BottomButtons';
import { navigate } from '@dvag/dfs-orchestrator-client/messengers';
import { pages } from '@dvag/dfs-constant-config';
import { useParams } from 'react-router-dom';

const FULL_COLUMN_COUNT = 3;

export const AdvisoryDashboard = () => {
  const { upperList } = useScreenData();
  const { householdId } = useParams();
  let size;
  const columnAmount = upperList.filter((item) => item.show);
  if (columnAmount.length === FULL_COLUMN_COUNT) {
    size = { mq1: '12/*', mq2: '12/*', mq3: '4-4-4' };
  } else {
    size = { mq1: '12/*', mq2: '6-6/12', mq3: '6-6' };
  }

  const navigateToNextSteps = () => {
    if (householdId) {
      navigate(pages.FIVE_STEPS.getUrl(householdId, true));
    }
  };

  const navigateToDocumentAppointment = () => {
    if (householdId) {
      navigate(pages.APPOINTMENT_DOCUMENTATION.getUrl(householdId, true));
    }
  };

  return (
    <>
      <DxProcessHeader
        headline={i18next.t('advisoryDashboard.headline')}
        data-testid="favorites-headline"
      />
      <DxSpacer size="8v" />
      <DxContainer type="page" color="transparent">
        <DxGrid mq1="12/12/12/12" rowgap="24v">
          <DxGrid mq1={size.mq1} mq2={size.mq2} mq3={size.mq3}>
            {upperList.map(
              (item) =>
                item.show && (
                  <TopCard
                    tag={item.id}
                    key={item.id}
                    title={item.title}
                    description={item.subtitle}
                    image={item.img}
                    onClick={item.onClick}
                    coverPosition={item.coverPosition}
                  />
                ),
            )}
          </DxGrid>

          <DxGrid mq1="12/*" mq3="6-6">
            <LeftCard showBalanceSheet />
            <RightCard isAdvisory />
          </DxGrid>
          <BottomButtons
            navigateToNextSteps={navigateToNextSteps}
            navigateToDocumentAppointment={navigateToDocumentAppointment}
          />
          <DxSpacer size="8v" />
        </DxGrid>
      </DxContainer>
    </>
  );
};
